import React from "react";
import { AppTheme } from "../../theme/App.theme";
const ImageThumbnail = ({ ImageUrl, OnClickHandler, IsForDataTable, IsRequiredForPrint, IsUsedForCompanyDetails }) => {
  const ImageThumbnailStyle = {
    width: IsForDataTable && IsRequiredForPrint ? "55px" : IsForDataTable ? "75px" : "90px",
    height: IsForDataTable && IsRequiredForPrint ? "55px" : IsForDataTable ? "70px": "80px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    borderRadius: '5px',
    border: IsUsedForCompanyDetails ? "none" : `1px solid ${AppTheme.MUTED}`,
    cursor: 'pointer'
  };
  
  return (
    <div
      style={{
        ...ImageThumbnailStyle,
        backgroundImage: `url(${ImageUrl})`,
      }}
      onClick={OnClickHandler}
    />
  );
};

export default ImageThumbnail;
